module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M16.3 7.9l-4.7-5.4L8 5.1l2.4 2.8H8v13h21v-13H16.3zM9 8.9h2.3l6.6 7.7 5.6 3.3H9v-11zm19 11h-4.2l-2.3-6-4.3-5H28v11z","fill":"#fff"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/tool_draw_rectangle.svg
// module id = 724
// module chunks = 2